import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Image as ImageModel } from '@common/core/models';
import { StoreService } from '@common/core/services';

@Component({
  selector: 'cci-image',
  templateUrl: './image.component.html',
  styleUrls: ['./image.component.scss'],
})
export class ImageComponent implements OnInit, OnChanges {
  @Input() image: ImageModel;
  @Input() loading: 'lazy' | 'eager' = 'lazy';
  @Input() showLoader = true;
  @Input() size: 'thumbnail' | 'small' | 'medium' | 'large' | 'zoom' = 'small';
  @Output() imageLoaded = new EventEmitter();
  @Output() imageLoading = new EventEmitter();
  isLoading = false;
  private timeoutHandler;
  constructor(private storeService: StoreService) {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.image && changes.image.currentValue !== changes.image.previousValue) {
      this.imageLoading.emit();
      this.timeoutHandler = setTimeout(() => {
        this.isLoading = true;
      }, 100);
      this.preloadImage();
    }
  }

  get imageName() {
    if (!this.image?.name) {
      return '';
    }

    return this.image.name
      .replace('.jpg', '')
      .replace('.jpeg', '')
      .replace('.png', '')
      .replace('.webp', '');
  }

  get imageUrl() {
    const url = this?.image?.url;
    if (!url) {
      return '';
    }

    const urlPrefixIndex = url.indexOf('upload/') + 7;
    const urlPrefix = url.slice(0, urlPrefixIndex);
    const urlPostfix = url.slice(urlPrefixIndex);
    let transformations = 'f_auto/ar_16:9,c_fill/';
    if (devicePixelRatio > 1.5) {
      transformations += `q_auto:${this.size === 'thumbnail' ? 'good' : 'low'}/dpr_${
        this.size === 'zoom' ? '1.8' : '1.5'
      }/`;
    } else {
      transformations += 'q_auto:good/';
    }
    const activeBreakpoints = this.storeService.store.activeBreakpoints;
    switch (this.size) {
      case 'thumbnail':
        if (activeBreakpoints.isHandset) {
          transformations += 'w_200/';
        } else {
          transformations += 'w_200/';
        }
        break;
      case 'small':
        if (activeBreakpoints.isHandset) {
          transformations += 'w_300/';
        } else {
          transformations += 'w_250/';
        }
        break;
      case 'medium':
        if (activeBreakpoints.isHandset) {
          transformations += 'w_350/';
        } else {
          transformations += 'w_433/';
        }
        break;
      case 'large':
        if (activeBreakpoints.isHandset) {
          transformations += 'w_348/';
        } else {
          transformations += 'w_1152/';
        }
        break;
      case 'zoom':
        if (activeBreakpoints.isHandset) {
          transformations += 'w_380/';
        } else {
          transformations += 'w_1600/';
        }
        break;
    }
    return urlPrefix + transformations + urlPostfix;
  }

  private preloadImage() {
    const img = new Image();
    img.src = this.imageUrl;
    img.onload = () => {
      this.imageLoaded.emit();
      clearTimeout(this.timeoutHandler);
      this.isLoading = false;
    };
  }
}
